<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="ListPosCustomer">
    <div class="form-search">
      <form @submit="onSearch">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <label for="firstName">Firstname </label>
            <input
              id="firstName"
              type="text"
              v-model="firstName"
              class="form-control"
              :style="firstNameError ? 'border-color: red' : ''"
            />
            <div v-if="firstNameError" class="text-error">
              {{ firstNameError }}
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <label for="lastName">Lastname </label>
            <input
              id="lastName"
              type="text"
              v-model="lastName"
              class="form-control"
              :style="lastNameError ? 'border-color: red' : ''"
            />
            <div v-if="lastNameError" class="text-error">
              {{ lastNameError }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="mobile">Mobile </label>
            <input
              id="mobile"
              type="text"
              v-model="mobile"
              class="form-control"
              :style="mobileError ? 'border-color: red' : ''"
            />
            <div v-if="mobileError" class="text-error">{{ mobileError }}</div>
          </div>
        </div>
        <div class="btnSearch">
          <button
            class="btn btn-outline-primary"
            style="margin-right: 1rem"
            @click="resetSearh"
            type="button"
          >
            Reset
          </button>
          <button class="btn btn-outline-success ok-btn" type="submit">
            OK
          </button>
        </div>
      </form>
    </div>
    <div class="list-pos-customer">
      <v-alert
        v-if="listCustomer.length <= 0 && flagClickSearh && !publicMessage"
        prominent
        dense
        dismissible
        type="warning"
      >
        {{ textNoData }}
      </v-alert>
      <v-alert
        v-if="publicMessage && flagClickSearh"
        prominent
        dense
        dismissible
        type="error"
      >
        {{ publicMessage }}
      </v-alert>
      <b-table
        v-if="listCustomer.length > 0 && flagClickSearh"
        class="table table-responsive table-bordered mt-5"
        hover
        :fields="fields"
        :items="listCustomer"
        :per-page="perPage"
        @sort-changed="sortCompare"
        responsive
      >
        <template #cell(action)="data">
          <div class="d-flex justify-center">
            <router-link
              v-if="pathName === 'PosCustomer'"
              :to="{ name: 'DetailPosCustomer', query: { id: data.item.id } }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
            <router-link
              v-else
              :to="{
                name: 'DetailCustomerProfile',
                query: { id: data.item.customerId },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        v-if="listCustomer.length > 0"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import POSService from "@/services/api/poscustomer.service.js";
import CustomerService from "@/services/api/customer.service.js";
export default {
  data() {
    return {
      pathName: this.$route.name,
      firstName: "",
      firstNameError: "",
      lastName: "",
      lastNameError: "",
      mobile: "",
      mobileError: "",
      perPage: 10,
      currentPage: 1,
      totalItems: 10,
      listCustomer: [],
      fields: [
        {
          key: "customerId",
          label: "Customer code",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "firstName",
          label: "Firstname",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "lastName",
          label: "Lastname",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "mobile",
          label: "Mobile",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
      ],
      sort: {
        key: null,
        type: false,
      },
      textNoData: "",
      flagClickSearh: false,
      publicMessage: "",
      isLoading: false,
    };
  },
  methods: {
    async getListPOS(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brand: this.brandSelected?.id,
          sortColumn: sort.key || "",
          sortType: sort.type || "",
          key: this.searchText,
          mobile: this.mobile,
          firstName: this.firstName,
          lastName: this.lastName,
        };
        await POSService.getListCustomers(param)
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            this.checkErrorField(data.errors, data.message);
            this.totalItems = data.totalItems;
            this.listCustomer = data.existingCustomers;
            this.listCustomer.sort(function (a, b) {
              return -(b.id - a.id);
            });
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    async getListCustomers(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brand: this.brandSelected?.id,
          sortColumn: sort.key || "",
          sortType: sort.type || "",
          key: this.searchText,
          mobile: this.mobile,
          firstname: this.firstName,
          lastname: this.lastName,
        };
        await CustomerService.getListCustomer(param)
          .then((res) => {
            const data = res.data;
            this.isLoading = false;
            this.checkErrorField(data.errors, data.message);
            this.totalItems = data.totalItems;
            this.listCustomer = data.customer.map((s) => {
              const customerData = s.dataElements;
              return {
                firstName: customerData.FirstName,
                lastName: customerData.LastName,
                mobile: customerData.Mobile,
                customerId: s.identifier,
              };
            });
            this.listCustomer.sort(function (a, b) {
              return -(b.id - a.id);
            });
          })
          .catch((err) => {
            this.isLoading = false;
            console.log("Error: ", err);
          });
      } catch (error) {
        this.isLoading = false;
        console.log("Error: ", error);
      }
    },
    checkErrorField(error, msg) {
      const errorFname = error.find((f) => f.fieldName === "firstname");
      const errorLname = error.find((f) => f.fieldName === "lastname");
      const errorMobile = error.find((f) => f.fieldName === "mobile");
      this.firstNameError = errorFname ? errorFname.message : "";
      this.lastNameError = errorLname ? errorLname.message : "";
      this.mobileError = errorMobile ? errorMobile.message : "";
      this.textNoData = "ไม่พบข้อมูล";
      this.publicMessage = msg;
    },
    onSearch() {
      this.listCustomer = [];
      this.flagClickSearh = true;
      this.isLoading = true;
      const sort = {
        key: null,
        type: false,
      };
      if (this.pathName === "PosCustomer") {
        this.getListPOS(sort);
      } else {
        this.getListCustomers(sort);
      }
    },
    resetSearh() {
      this.firstName = "";
      this.lastName = "";
      this.mobile = "";
    },
    changePage() {
      if (this.pathName === "PosCustomer") {
        this.getListPOS(this.sort);
      } else {
        this.getListCustomers(this.sort);
      }
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      if (this.pathName === "PosCustomer") {
        this.getListPOS(this.sort);
      } else {
        this.getListCustomers(this.sort);
      }
    },
  },
};
</script>

<style lang="scss">
.btnSearch {
  padding: 3rem 0;
  display: flex;
  justify-content: flex-end;

  .ok-btn:disabled {
    color: #222;
    border-color: #222;
  }
}
</style>
